import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import { env } from '@/lib/env';

import styles from './TargetProduct.module.scss';
import { CustomInitContext } from '@/components/CustomTravel/CustomInit';
import { Image } from '@/components/Image';
import { format } from '@/utils/date';

const cx = classNames.bind(styles);

const TargetProduct: React.FC = () => {
  const { overseasProduct, overseasAgent } = useContext(CustomInitContext);

  return (
    <div className={cx('TargetProduct')}>
      <figure className={cx('figure')}>
        <Image
          src={`${env('THUMBNAIL_CDN')}${overseasProduct?.productFamily.images[0]}&type=f174_174`}
          alt={overseasProduct?.productName || ''}
        />
      </figure>
      <div className={cx('meta')}>
        <span className={cx('product')}>{overseasProduct?.productName}</span>
        <div className={cx('row')}>
          <div className={cx('agent')}>
            <img src={overseasAgent?.agtLogoUrl} alt={overseasProduct?.productName} />
            <span className={cx('name')}>
              {overseasProduct?.productFamily?.trafficAir?.detail?.departures?.[0]?.airlineName ?? '항공권 불포함'}
            </span>
          </div>
          <span className={cx('duration')}>
            {format(overseasProduct?.beginDate || '', localDateFormat)} ~&nbsp;
            {format(overseasProduct?.endDate || '', localDateFormat)}
          </span>
        </div>
      </div>
    </div>
  );
};

const localDateFormat = 'MM.DD.dd';

export default TargetProduct;
